import React, { Component } from 'react';
import styles from './GenericIcon.scss';
const rootClassName = styles.rootClassName;

class DislikeIcon extends Component {
  render() {
    const style = {
      ...(this.props.style || {}),
    };
    return (
      <svg
        className={rootClassName}
        viewBox='0 0 8 21'
        fill='currentColor'
        xmlns='http://www.w3.org/2000/svg'
        style={style}
      >
        <path
          d='M7.125 17.375C7.125 18.2344 6.8125 18.9635 6.1875 19.5625C5.58854 20.1875 4.85938 20.5 4 20.5C3.14062 20.5 2.39844 20.1875 1.77344 19.5625C1.17448 18.9635 0.875 18.2344 0.875 17.375C0.875 16.5156 1.17448 15.7865 1.77344 15.1875C2.39844 14.5625 3.14062 14.25 4 14.25C4.85938 14.25 5.58854 14.5625 6.1875 15.1875C6.8125 15.7865 7.125 16.5156 7.125 17.375ZM1.22656 1.47656L1.77344 12.1016C1.77344 12.362 1.86458 12.5833 2.04688 12.7656C2.22917 12.9219 2.45052 13 2.71094 13H5.28906C5.54948 13 5.77083 12.9219 5.95312 12.7656C6.13542 12.5833 6.22656 12.362 6.22656 12.1016L6.77344 1.47656C6.77344 1.21615 6.68229 0.994792 6.5 0.8125C6.31771 0.604167 6.09635 0.5 5.83594 0.5H2.16406C1.90365 0.5 1.68229 0.604167 1.5 0.8125C1.31771 0.994792 1.22656 1.21615 1.22656 1.47656Z'
          fill='currentColor'
        />
      </svg>
    );
  }
}

export default DislikeIcon;
